import styled, { keyframes } from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  height: 100%;
  width: 100%;
  background: linear-gradient(0deg, #0f172a 0%, #1e293b 33.85%, #334155 100%);
  @media (min-width: 1024px) {
    background-repeat: no-repeat;
    background-position: right bottom;
  }
`;

const PaymentSectionLayout = styled.div`
  flex: 1 0 auto;
  margin-bottom: 70px;
  @media (min-width: 1024px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 80px;
      max-width: 1150px;
      margin: 40px auto 0;
      width: 100%;
    }
  @media (max-width: 767px) { {
      margin-top: 0px;
      width: 100%;
    }
`;

const LoadingContainer = styled.div`
  position: absolute;
  font-weight: 400;
  font-size: 25px;
  line-height: 21px;
  top: 305px;
  width: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DotAnimation = keyframes`
  0% {
    margin-bottom: 0;
  }

  50% {
    margin-bottom: 0.5rem;
  }

  100% {
    margin-bottom: 0;
  }
`;

interface DotProps {
  delay: string;
}

const Dot = styled.div`
  background-color: white;
  border-radius: 50%;
  width: 0.25rem;
  height: 0.25rem;
  margin: 1rem 0.15rem;
  animation: ${DotAnimation} 0.5s linear infinite;
  animation-delay: ${(props: DotProps) => props.delay};
`;

export { Wrapper, PaymentSectionLayout, LoadingContainer, Dot };
